import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	Container,
	Button,
	Form,
	Row,
	Col,
	FormControl,
	InputGroup,
	Spinner,
} from 'react-bootstrap';
import '../../../assets/css/AddNewJob.css';
import { PlusCircleIcon } from '@primer/octicons-react';
import { HorizontalRuleIcon } from '@primer/octicons-react';
import { ReqPost } from '../../../config/Requests';
import { useNavigate } from 'react-router-dom';
import {
	getLocation,
	getLocationDetailByPlaceId,
} from '../../../config/Requests';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { showLoader, hideLoader } from '../../../helper/loader';
import { ReqGet } from '../../../config/Requests';
import _, { findIndex } from 'lodash';
import SuggestTags from '../SuggestTags';
import Select from 'react-select';
import { Header, Footer } from '../../Container';
import { Multiselect } from 'multiselect-react-dropdown';
import { formattedTags, formattedTitles } from '../../../helper/utils';
import { dateFormatter } from '../../../helper/dateFormater';
import { AiFillTags } from 'react-icons/ai';

import { BsBookmarkCheck } from 'react-icons/bs';
import { RxCrossCircled } from 'react-icons/rx';
import { ImCross } from 'react-icons/im';
import { remove } from 'lodash';
import ParentTagsScreen from './ParentTags';
import ChildTagsScreen from './ChildTags';
import NewChildTag from './NewChildTag';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { MdInfo } from 'react-icons/md';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import { Stack } from '@mui/system';
function AddNewJob() {
	const profile = useSelector(user => user.auth?.profile);
	const [showTooltip, setShowTooltip] = useState(false);
	const [feeError, setFeeError] = useState('');
	const [startPay, setStartPay] = useState(0);
	const [endPay, setEndPay] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [travel, setTravel] = useState(false);
	const [overtime, setOvertime] = useState(false);
	const [security, setSecurity] = useState(false);
	const [load, setLoad] = useState(false);
	const [selectedTags, setSelectedTags] = useState([]);
	const [chosenTags, setChosenTags] = useState([]);
	const [tags, setTags] = useState([]);
	const [childTags, setChildTags] = useState([]);
	const [childTags2nd, setChildTags2nd] = useState([]);
	const [statesData, setStatesData] = useState([]);
	const [citiesData, setCitiesData] = useState([]);
	const [tools, setTools] = useState(['']);
	const [expertise, setExpertise] = useState(['']);
	const [otherRequirements, setOtherRequirements] = useState(['']);
	// add job type and worker type
	const [jobType, setJobType] = useState(profile?.job_type);
	const [workerType, setWorkerType] = useState(profile?.worker_type);
	const [parentShow, setParentShow] = useState(false);
	const [childrenShow, setChildrenShow] = useState(false);
	const [selectedChild, setSelectedChild] = useState([]);
	const [selectedChild2nd, setSelectedChild2nd] = useState([]);
	const [childSelected, setChildSelected] = useState([]);

	const [show, setShow] = useState(true);

	const [activeList, setActiveList] = useState([]);
	const [parent, setParent] = useState('');
	const [manager, setManager] = useState({
		full_name: '',
		phone_number: '',
		email: '',
	});
	const [selectedMustOwnTools, setSelectedMustOwnTools] = useState([]);
	const [ClientProvidesTools, setClientProvidesTools] = useState([]);

	const [selectedParent, setSelectredParent] = useState([]);
	const [selectedParent2, setSelectredParent2] = useState([]);
	const [selectedChild2, setSelectedChild2] = useState([]);
	const [selectedChild3, setSelectedChild3] = useState([]);
	const [childTags2, setChildTags2] = useState([]);
	const [childTags3, setChildTags3] = useState([]);
	const [checked1, setChecked1] = useState([]);
	const [childChecked, setChildChecked] = useState([]);
	const [childChecked2nd, setChildChecked2nd] = useState([]);
	const [childChecked2, setChildChecked2] = useState([]);
	const [childChecked3, setChildChecked3] = useState([]);
	const [checked2, setChecked2] = useState([]);
	const [city, setCity] = useState('');
	const today = new Date();
	let currentDate = new Date(
		today.getFullYear(),
		today.getMonth(),
		today.getDate(),
		0,
		0,
		0
	);
	const days = 15;
	currentDate = currentDate.setDate(currentDate.getDate() + days);
	currentDate = new Date(currentDate);
	console.log('child1', childChecked);
	console.log('child2', childChecked2);
	let todayDate = new Date();
	todayDate = dateFormatter(todayDate, 'YYYY-MM-DD');

	const handleInputChangeExpertise = (e, index) => {
		const { name, value } = e.target;
		const list = [...expertise];
		list[index] = value;
		setExpertise(list);
	};

	const handleInputChangeTools = (e, index) => {
		const { name, value } = e.target;

		const list = [...tools];
		list[index] = value;
		setTools(list);
	};

	const handleInputChangeOtherRequirement = (e, index) => {
		const { name, value } = e.target;

		const list = [...otherRequirements];
		list[index] = value;
		setOtherRequirements(list);
	};

	// remove
	const handleRemoveExpertise = index => {
		const list = [...expertise];
		list.splice(index, 1);
		setExpertise(list);
	};

	const handleRemoveTools = index => {
		const list = [...tools];
		list.splice(index, 1);
		setTools(list);
	};

	const handleRemoveOtherRequirement = index => {
		const list = [...otherRequirements];
		list.splice(index, 1);
		setOtherRequirements(list);
	};

	const handleAddExpertise = () => {
		setExpertise([...expertise, '']);
	};

	const handleAddTools = () => {
		setTools([...tools, '']);
	};

	const handleAddOtherRequirements = () => {
		setOtherRequirements([...otherRequirements, '']);
	};

	useEffect(() => {
		// only tag ids will be sent in request 'ChosenTags' and selectedTags used to show in dropdown field
		let selected = [];

		tags.map(tag => {
			tag.child_tags.map(child => {
				if (chosenTags.includes(child.id)) {
					selected = [
						{ label: child.display_name, value: child.id, id: child.id },
						...selected,
					];
				}
			});
		});

		setSelectedTags(selected);
	}, [chosenTags]);

	useEffect(() => {
		if (startPay > endPay) {
			setFeeError('start value must be greater then end value');
		} else {
			setFeeError('');
		}
	}, [startPay, endPay]);

	const initialValues = {
		title: '',
		job_id: '',
		// parent_tag:'',
		// child_tag:'',
		description: '',
		address: '',
		// specific_qualification: "",
		start_pay_range: '',
		start_pay_range1: '',
		end_pay_range: '',
		end_pay_range1: '',
		job_location: '',
		requires_travel: false,
		overtime: false,
		onsite_meetings: '',
		travel_duration: '',
		destination: '',
		travel_type: '',
		remote_job: '',
		software_experience: '',
		security_level: '',
		start_date: '',
		end_date: '',
		location_lat: 64,
		location_lng: 48,
		worker_type: '',
		job_type: '',
		Location: '',
		priority: 'High',
		year_experience: '',
		poc_title: '',
		poc_email: '',
		poc_phone: '',
		states: '',
		cities: '',
		max_applicants: '',
		tag_parent_id: null,
		manager_name: '',
		manager_email: '',
		manager_phone: '',
		city: '',
	};

	const validationSchema = Yup.object().shape(
		{
			title: Yup.string()
				.required('*Title is required')
				.max(100, 'Title should not be more than 100 characters')
				.min(3, 'Title should contain at least 3 characters'),

			job_id: Yup.string()
				.required('* Job Id is required')
				.matches(/^[0-9]+$/, 'Job Id should contain only numeric characters')
				.max(20, 'Job Id should not be more than 20 characters')
				.min(1, 'Job Id should contain at least 1 characters'),
			description: Yup.string().required('*Description is required'),
			// specific_qualification: Yup.string().required(
			//   "*Specific Qualification is required"
			// ),
			start_pay_range: Yup.number()
				.positive('*Must be positive number')
				.required('*This field is required'),
			end_pay_range: Yup.number()
				.positive('*Must be positive number')
				.required('*This field is required'),
			// .min(
			//   Yup.ref("Start_pay_range"),
			//   "Max Pay rate must be greater then starter"
			// ),
			start_date: Yup.date()
				.required('*This field is required')
				.min(
					new Date(currentDate),
					'Start Date must be Greater then 15 Days of Current Date'
				),
			end_date: Yup.date()
				.required('*This field is required')
				.min(Yup.ref('start_date'), 'End date must be greater than start date'),
			job_location: Yup.string().required('*This field is required'),
			// remote_job: Yup.string()
			//   .required("*This field is required"),
			worker_type: Yup.string().required('*Worker type is required'),
			onsite_meetings: Yup.string().required('*Onsite Meeting is required'),
			job_type: Yup.string().required('*Job type is required'),
			priority: Yup.string().required('*Priority Level is required'),
			year_experience: Yup.string().required('*years experience is required'),
			// parent_tag: Yup.string()
			//   .required("At least Parent Tag is required"),
			// child_tag: Yup.string()
			//   .required("At least One Child Tag is required"),
			max_applicants: Yup.number()
				.positive('*Must be positive number')
				.required('*No. of Positions Required'),
			states: Yup.string().when(['job_location'], {
				is: job_location => job_location !== 'remote',
				then: () => Yup.string().required('*This field is required'),
			}),
			// cities: Yup.string().when(["job_location"], {
			//   is: (job_location) => job_location !== "remote",
			//   then: Yup.string().required("*This field is required"),
			// }),
			manager_name: Yup.string().required('*Name is required'),
			manager_email: Yup.string()
				.required('*Email is required')
				.matches(
					/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
					'*Please enter a valid email address'
				),
			manager_phone: Yup.string()
				.required('*Phone number is required')
				.matches(/^\d{10}$/, '*Phone number must be 10 digits'),
			city: Yup.string().required('*City is required'),
		},
		[['job_location']]
	);

	useEffect(() => {
		ReqGet('tags')
			.then(res => {
				setTags(res.data.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		//get states
		ReqGet('states')
			.then(res => {
				setStatesData(res.data);
				//call cities api
				if (res.data[0].id) {
					ReqGet('cities/' + res.data[0].id)
						.then(res => {
							console.log(statesData);
							setCitiesData(res.data);
						})
						.catch(err => {
							console.log(err.message);
						});
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	const returnedTags = formattedTags(tags);

	const [locations, setLocations] = useState([]);

	const SetWorkType = e => {
		setWorkerType(e.target.value);
	};

	const handleLocationSearch = (keyword, cb) => {
		getLocation(keyword).then(res => {
			cb(res?.data?.predictions);
		});
	};

	const handleLocationChange = (obj, setFieldValue) => {
		if (obj && obj.length > 0) {
			getLocationDetailByPlaceId(obj[0].place_id).then(response => {
				const res = response.data.results[0];
				if (res) {
					setFieldValue('address', res.formatted_address);
					setFieldValue('location_lat', res.geometry.location.lat);
					setFieldValue('location_lng', res.geometry.location.lng);
				}
			});
		}
	};
	const handleChangeMustOwnTools = selectedValue => {
		setSelectedMustOwnTools([...selectedMustOwnTools, selectedValue]);
	};

	const handleChangeClientProvidesTools = selectedValue => {
		setClientProvidesTools([...ClientProvidesTools, selectedValue]);
	};
	console.log(selectedMustOwnTools, 'heloass');

	const formSubmit = values => {
		
		if (expertise && expertise.length <= 1 && expertise.includes('')) {
			toast.error(`Please add at least 1  Required Skills`);

			return;
		}
		// if (
		//   otherRequirements &&
		//   otherRequirements.length <= 1 &&
		//   otherRequirements.includes("")
		// ) {

		//   return;
		// }
		if (tools && tools.length <= 1 && tools.includes('')) {
			toast.error(`Please add at least 1 tools`);

			return;
		}
		const getChild = [];
		if (selectedChild.length < 1) {
			toast.error(`Please select atleast 1 children tag`);

			return;
		}
		selectedChild.filter(d1 => getChild.push(d1.value));
		selectedChild2nd.filter(d1 => getChild.push(d1.value));
		selectedChild2.filter(d1 => getChild.push(d1.value));
		selectedChild3.filter(d1 => getChild.push(d1.value));

		// const params = {
		//   ...values,
		//   requires_travel: travel,
		//   overtime: overtime,
		// tags: getChild,
		//   tool: tools,
		//   other_requirements: otherRequirements,
		//   specific_expertise: expertise,
		//   child_tag_1: childChecked,
		//   child_tag_2: childChecked2nd,
		//   child_tag_3: childChecked2,
		//   child_tag_4: childChecked3
		//   tags: getChild,
		//   ...childTags,
		// };
		const params = {
			...values,
			requires_travel: travel,
			overtime: overtime,
			tool: tools,
			other_requirements: otherRequirements,
			specific_expertise: expertise,
			child_tag_1: childChecked,
			child_tag_2: childChecked2nd,
			child_tag_3: childChecked2,
			child_tag_4: childChecked3,
			tags: getChild,
			must_own_tools: selectedMustOwnTools,
			client_provides_tools: ClientProvidesTools,
		};

		setLoader();
		// showLoader();
		

		ReqPost('jobs', params)
			.then(res => {
				if (res.status === 200) {
					setLoad(false);
					if (params.published) {
						navigate(`/job-post-success`);
					} else {
						navigate(`/job-draft-success`);
					}
				} else {
					setLoad(false);
					toast.error(res.data.message);
				}
			})
			.catch(err => {
				console.log(err.response);
			})
			.finally();
	};

	const handleButtonClick = (published, setFieldValue, submitForm, errors) => {
		
		setFieldValue('published', published);
		submitForm();
		console.log('published123', errors);
		if (Object?.keys(errors)?.length !== 0) {
			toast.error(
				`Please fill correct & fill out all required fields in the form`
			);
		}
	};

	const securityFunction = () => setSecurity(!security);

	const setLoader = () => setLoad(!load);

	const loadcities = (id, setFieldValue) => {
		ReqGet('cities/' + id)
			.then(res => {
				setCitiesData(res.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		setFieldValue('states', id);
	};

	const selectTags = tags => {
		let selected = [];
		tags.map((data, i) => {
			selected.push(data.value);
		});
		setChosenTags(selected);
	};
	const checkTravel = e => {
		console.log(e.target.value, 'eee', e.target.checked);
		initialValues.requires_travel = e.target.checked;
		setTravel(e.target.checked);
		console.log(initialValues.requires_travel, 'b');
	};
	const overtimeTravel = e => {
		console.log(e.target.value, 'eee', e.target.checked);
		initialValues.overtime = e.target.checked;
		setOvertime(e.target.checked);
		console.log(initialValues.overtime, 'b');
	};
	// 1st Parent
	const selectParentTag = (e, d1) => {
		const { checked, value } = e.target;
		console.log(d1, 'helloooo');
		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent([d1]);
			setChecked1([d1.value]);
		} else {
			setSelectredParent([]);
			setChecked1([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags(formattedTags(res.data.data));
					setChildTags2nd(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags([]);
			setChildTags2nd([]);
			setChildChecked([]);
			setChildChecked2nd([]);
			setSelectedChild([]);
			setSelectedChild2nd([]);
		}
		setChildChecked([]);
		setChildChecked2nd([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	// 2nd Parent
	const selectParentTag2 = (e, d1) => {
		const { checked, value } = e.target;

		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent2([d1]);
			setChecked2([d1.value]);
		} else {
			setSelectredParent2([]);
			setChecked2([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags2(formattedTags(res.data.data));
					setChildTags3(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags2([]);
			setChildTags3([]);
			setChildChecked2([]);
			setChildChecked3([]);
			setSelectedChild2([]);
			setSelectedChild3([]);
		}
		setChildChecked2([]);
		setChildChecked3([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	//1st Child

	const childSelection = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked([...childChecked, result.value]);
			setSelectedChild([...selectedChild, result]);
		} else {
			let f1 = [...selectedChild];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild([...f1]);
		}

		// const { value, checked } = e.target;
		// let d3 = JSON.parse(e.target.value);
		// d3 = { ...d3, parent: parent };
		// if (!checked) {
		//   setActiveList(activeList.filter((d1) => d1 != d3.value));
		//   return setSelectedChild(
		//     selectedChild.filter((d1) => d1.value != d3.value)
		//   );
		// }

		// // selectRow
		// setActiveList([...activeList, d3.value]);
		// setSelectedChild([...selectedChild, d3]);
	};
	// 2nd child
	const childSelection2nd = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2nd([...childChecked2nd, result.value]);
			setSelectedChild2nd([...selectedChild2nd, result]);
		} else {
			let f1 = [...selectedChild2nd];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2nd];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2nd(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild2nd([...f1]);
		}
	};

	///3rd child

	const childSelection2 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2([...childChecked2, result.value]);
			setSelectedChild2([...selectedChild2, result]);
		} else {
			let f1 = [...selectedChild2];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2(checkCild);

			return setSelectedChild2([...f1]);
		}
	};
	// 4th child
	const childSelection3 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked3([...childChecked3, result.value]);
			setSelectedChild3([...selectedChild3, result]);
		} else {
			let f1 = [...selectedChild3];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked3];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked3(checkCild);

			return setSelectedChild3([...f1]);
		}
	};
	///
	const [selectedValue, setSelectedValue] = useState(''); // State to store the selected value

	const handleDropdownChange = event => {
		setSelectedValue(event.target.value); // Update the selected value when the dropdown changes
	};
	console.log('selection Comit', selectedChild);
	const okFun = () => {
		if (selectedChild.length < 1) {
			toast.error(`Please select atleast 1 children tag`);

			return;
		}
		setChildrenShow(false);
		// setSelectedChild([])
		setChildSelected([...selectedChild]);
	};
	const showParent = () => {
		setParentShow(true);
		setChildrenShow(false);
	};
	const removeTag = id => {
		setChildSelected(childSelected.filter(d2 => d2.value != id));
		setSelectedChild(selectedChild.filter(d1 => d1.value != id));

		setActiveList(activeList.filter(d1 => d1 != id));
	};

	const hideParentTag = () => {
		setParentShow(false);
	};
	const hideChildrenTag = tag1 => {
		if (selectedChild.length < 1 && tag1 !== 'cross') {
			toast.error(`Please select at least 1 Child Tag`);
		}
		setChildrenShow(false);
	};

	const navigate = useNavigate();

	//

	const iconStyle = {
		cursor: 'pointer',
		width: '80%',
		height: '0%',
	};

	const tooltipStyle = {
		position: 'absolute',
		bottom: '100%',
		left: '50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#333',
		color: '#fff',
		padding: '5px',
		borderRadius: '5px',
		width: '742%',
		display: showTooltip ? 'block' : 'none',
	};
	return (
		<Container fluid='true' style={{ zIndex: -400 }}>
			<Header type='client' />
			{load ? <div className='loader-css'></div> : ''}
			<Container className='add-new-job'>
				<Row>
					<Col>
						<div className='mt-2 mb-3 recruiter_actions' />
						<div className={'top-actions'}>
							<h4 className={'text-orange'} onClick={() => setLoader()}>
								{/* Submit new job opportunity */}
							</h4>
							<Button
								className='btn_cancel'
								variant='primary'
								onClick={() => navigate('/')}
							>
								Cancel
							</Button>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<Formik
							initialValues={initialValues}
							validationSchema={validationSchema}
							onSubmit={(values, { setSubmitting, resetForm }) => {
								
								console.log('Values About fee', values);
								formSubmit(values, setSubmitting, resetForm);
							}}
						>
							{({
								errors,
								touched,
								values,
								handleSubmit,
								handleChange,
								setFieldValue,
								submitForm,
								handleBlur,
								isSubmitting,
							}) => (
								<Form>
									{/* Create New Job Opportunity */}
									<Form style={{ border: '1px solid', marginTop: '12px' }}>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														New Job Opportunity
													</h4>
												</div>
											</Col>
										</Row>
										{/* Priority Level */}

										<Row style={{ marginLeft: '4px' }}>
											<h4 className={'heading mb-2 fw-bold p-2 ms-2 rounded'}>
												Administrative Data
											</h4>
											<Col sm={6}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className=' fw-bold'>
														Priority Level:
														{/* <span style={{ color: "red" }}>*</span> */}
													</InputGroup.Text>

													<Form.Control
														as='select'
														custom
														name='priority'
														onChange={handleChange}
														placeholder='Select Level'
														required
													>
														<option value='high'>High</option>
														<option value='medium'>Medium</option>
														<option value='standard'>Low</option>
													</Form.Control>
												</InputGroup>
											</Col>

											{/*  Security Clearance*/}
											<Col sm={6}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														Security Clearance Required:
														{/* <span style={{ color: "red" }}>*</span> */}
													</InputGroup.Text>

													<Form.Group
														controlId='newJobDestination'
														className='ms-3 mt-1'
													>
														{/* <Form.Label className="text-orange">Level</Form.Label> */}
														<div key={`custom-inline-checkbox`}>
															<Form.Check
																custom
																inline
																label='ITAR'
																onChange={handleChange}
																name='security_level'
																value='1'
																type={`radio`}
																id={`itar`}
															/>
															<Form.Check
																custom
																inline
																label='Secret'
																onChange={handleChange}
																name='security_level'
																value='2'
																type={`radio`}
																id={`secret`}
															/>
															<Form.Check
																custom
																inline
																label='Top Secret'
																onChange={handleChange}
																name='security_level'
																value='3'
																type={`radio`}
																id={`top-secret`}
															/>
														</div>
													</Form.Group>
												</InputGroup>
											</Col>

											{/* No. of Positions */}
											<Col sm={6} className='mt-4'>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														No. of Positions:
														{/* <span style={{ color: "red" }}>*</span> */}
													</InputGroup.Text>

													<Form.Control
														onChange={handleChange}
														type='Number'
														min='0'
														oninput='this.value = Math.abs(this.value)'
														value={values.max_applicants}
														name='max_applicants'
														rows='1'
														className={`${
															errors.max_applicants && touched.max_applicants
																? 'error'
																: ''
														}`}
														placeholder='Enter No. of Positions'
													/>
													{errors.max_applicants && touched.max_applicants ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.max_applicants}
														</div>
													) : null}
												</InputGroup>
											</Col>
										</Row>

										{/* Date */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3  rounded'>
												{' '}
												Date{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mb-4'>
												<Form.Group className='pl-5 mt-4'>
													<Stack direction={'row'} gap={1.7}>
														<Col xs='auto'>
															<Form.Label style={{ fontWeight: 'bold' }}>
																{' '}
																Start Date:{' '}
															</Form.Label>{' '}
														</Col>
														<Col sm md={4}>
															<FormControl
																placeholder='Select Start Date'
																aria-label='Username'
																aria-describedby='basic-addon1'
																type='date'
																onChange={handleChange}
																name='start_date'
																min={todayDate}
																max={values.end_date}
															/>
															{errors.start_date && touched.start_date ? (
																<div
																	className={`red mb-1 fs15`}
																	style={{ color: 'red' }}
																>
																	{errors.start_date}
																</div>
															) : null}
														</Col>
														<Col md={1} className='ms-5 mt-1'>
															{/* <div className="infoDate">
                                Start date must be Greater <br /> then 15 Days
                                of Current day
                              </div> */}
															<div
																style={{
																	position: 'relative',
																	display: 'inline-block',
																}}
															>
																<MdInfo
																	style={iconStyle}
																	onMouseEnter={() => setShowTooltip(true)}
																	onMouseLeave={() => setShowTooltip(false)}
																/>
																<div style={tooltipStyle}>
																	Start date must be Greater <br /> than 15 Days
																	of Current day
																</div>
															</div>
														</Col>

														<Col xs='auto'>
															
															<Form.Label style={{ fontWeight: 'bold' }}>
																
																End Date:{' '}
															</Form.Label>
														</Col>
														<Col sm md={4}>
															<FormControl
																placeholder='Select Start Date'
																aria-label='Username'
																aria-describedby='basic-addon1'
																type='date'
																onChange={handleChange}
																name='end_date'
																min={values.start_date}
															/>
															{errors.end_date && touched.end_date ? (
																<div
																	className={`red mb-1 fs15`}
																	style={{ color: 'red' }}
																>
																	{errors.end_date}
																</div>
															) : null}
														</Col>
													</Stack>
												</Form.Group>
											</Col>
										</Row>

										{/* Job Requesting Manager */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Job Requesting Manager{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '15px',
											}}
										>
											<Col sm={12}>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{/* {references.map((item, i) => { */}

														<InputGroup
															controlId='formBasicEmail'
															className='mb-4 mt-2'
														>
															<InputGroup.Text className='fw-bold'>
																Full Name:
																<span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>

															<Form.Control
																maxlength='30'
																name='manager_name'
																onChange={handleChange}
																type='text'
																placeholder='Enter Full Name'
																defaultValue={manager.full_name}
																// value={manager.full_name}
															/>
															{errors.manager_name && touched.manager_name ? (
																<div
																	className={`red mb-1 fs15`}
																	style={{ fontWeight: '400', color: 'red' }}
																>
																	{errors.manager_name}
																</div>
															) : null}
														</InputGroup>

														<Row>
															<Col sm={6}>
																<InputGroup
																	controlId='formBasicEmail'
																	className='mb-4'
																>
																	<InputGroup.Text className='fw-bold'>
																		Email:
																		<span style={{ color: 'red' }}>*</span>
																	</InputGroup.Text>

																	<Form.Control
																		name='manager_email'
																		onChange={handleChange}
																		type='text'
																		placeholder='Enter Email Address'
																		defaultValue={manager.email}
																		// value={manager.email}
																	/>
																	{errors.manager_email &&
																	touched.manager_email ? (
																		<div
																			className={`red mb-1 fs15`}
																			style={{
																				fontWeight: '400',
																				color: 'red',
																			}}
																		>
																			{errors.manager_email}
																		</div>
																	) : null}
																</InputGroup>
															</Col>
															<Col sm={6}>
																<InputGroup
																	controlId='formBasicEmail'
																	className='mb-2'
																>
																	<InputGroup.Text className='fw-bold'>
																		Phone Number:
																		<span style={{ color: 'red' }}>*</span>
																	</InputGroup.Text>

																	<Form.Control
																		maxlength='50'
																		name='manager_phone'
																		onChange={handleChange}
																		type='text'
																		placeholder='Enter Phone Number'
																		// defaultValue={manager.phone_number}
																		// value={manager.phone_number}
																	/>
																	{errors.manager_phone &&
																	touched.manager_phone ? (
																		<div
																			className={`red mb-1 fs15`}
																			style={{
																				fontWeight: '400',
																				color: 'red',
																			}}
																		>
																			{errors.manager_phone}
																		</div>
																	) : null}
																</InputGroup>
															</Col>
														</Row>

														<div>
															<div className='btn-box'>
																{/* <Button variant="outline-success">Success</Button>
                                      {references.length !== 1 && <Button variant="outline-danger"
                                        style={{ marginRight: '48px' }}
                                        onClick={() => handleRemove(i, references, setReferences)}>Remove this Reference</Button>}
                                      {references.length - 1 === i &&
                                        <Button variant="outline-success" onClick={() => setReferences([...references, { first_name: "", last_name: "", email: "", type_of_reference: "" }])}>Add a Reference</Button>} */}
															</div>
														</div>

														{/* }) */}
													</li>
												</ul>
											</Col>
										</Row>
									</Form>

									{/*Job Profile  */}
									<Form style={{ border: '1px solid', marginTop: '12px' }}>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Job Profile
													</h4>
												</div>
											</Col>
										</Row>
										{/* Priority Level */}

										<h4 className={'heading fw-bold p-2 ms-2 rounded'}>
											General Data
										</h4>
										<Row style={{ marginLeft: '4px' }}>
											{/* Job ID # */}
											<Col sm={4}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														Project ID #:
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>

													<Form.Control
														onChange={handleChange}
														value={values.job_id}
														maxlength='20'
														name='job_id'
														rows='1'
														className={`${
															errors.job_id && touched.job_id ? 'error' : ''
														}`}
														placeholder='Enter project Id here'
													/>
													{errors.job_id && touched.job_id ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.job_id}
														</div>
													) : null}
												</InputGroup>
											</Col>

											{/* Job Title */}
											<Col sm={7}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														Job Title:
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>

													<Form.Control
														onChange={handleChange}
														value={values.title}
														maxlength='70'
														name='title'
														rows='1'
														className={`${
															errors.title && touched.title ? 'error' : ''
														}`}
														placeholder='Enter job title here'
													/>
													{errors.title && touched.title ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.title}
														</div>
													) : null}
												</InputGroup>
											</Col>
										</Row>

										{/* Worker Type */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Worker Type <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12}>
												<Form.Group
													controlId='newJobDestination'
													className='ms-5 mt-4 '
												>
													<div key={`custom-inline-checkbox`}>
														<Form.Check
															custom
															inline
															name='worker_type'
															onChange={handleChange}
															label='1099 Subcontractor'
															value='1099-subcontractor'
															type={`radio`}
															id={`job-type-1099-subcontractor`}
														/>
														<Form.Check
															custom
															inline
															name='worker_type'
															onChange={handleChange}
															value='w2-contingent-worker'
															label='W2 Contingent Worker'
															type={`radio`}
															id={`job-type-w2-contingent-worker`}
														/>
														<Form.Check
															custom
															inline
															name='worker_type'
															onChange={handleChange}
															value='W-2-contingent-to-direct-hire'
															label='W-2 Contingent to Direct Hire'
															type={`radio`}
															id={`job-type-W-2_Contingent_to_Direct_Hire`}
														/>
														<Form.Check
															custom
															inline
															name='worker_type'
															onChange={handleChange}
															value='direct-hire-only'
															label='Direct Hire Only'
															type={`radio`}
															id={`job-type-direct-dire-only`}
														/>
														{/* <Form.Check
                            custom
                            inline
                            name="worker_type"
                            onChange={handleChange}
                            value="part-time-contingent"
                            label="Direct Hire"
                            type={`radio`}
                            id={`job-type-part-time-contingent`}
                          /> */}
													</div>
													{errors.worker_type && touched.worker_type ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.worker_type}
														</div>
													) : null}
												</Form.Group>
											</Col>
										</Row>
										{/* Job Type */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Job Type <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12}>
												<Form.Group
													controlId='newJobDestination'
													className='ms-5 mt-4'
												>
													<div key={`custom-inline-checkbox`}>
														<Form.Check
															custom
															inline
															label='Full Time'
															name='job_type'
															type='radio'
															id='fullTime'
															value='fullTime'
															onChange={handleChange}
														/>
														<Form.Check
															custom
															inline
															label='Part-Time'
															name='job_type'
															type='radio'
															id='halfTime'
															value='halfTime'
															onChange={handleChange}
														/>
														<Form.Check
															custom
															inline
															label='Full Time and Part-Time'
															name='job_type'
															type='radio'
															id='both'
															value='both'
															onChange={handleChange}
														/>
														{errors.job_type && touched.job_type ? (
															<div
																className={`red mb-1 fs15`}
																style={{ color: 'red' }}
															>
																{errors.job_type}
															</div>
														) : null}
													</div>
												</Form.Group>
											</Col>
										</Row>
										{/* Job Location */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Job Location <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '16px',
											}}
										>
											<Col sm={12} style={{ marginBottom: '15px' }}>
												<Row style={{ marginTop: '15px' }}>
													<Col sm={6}>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text className='fw-bold'>
																State:<span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>

															<Form.Control
																as='select'
																custom
																name='states'
																onChange={event =>
																	loadcities(event.target.value, setFieldValue)
																}
																placeholder='Select State'
																required
															>
																<option value='' disabled selected>
																	Select State
																</option>
																return(
																{statesData.map((item, i) => {
																	return (
																		<option key={i} value={item.id}>
																			{item.name}
																		</option>
																	);
																})}
																)
															</Form.Control>
															{errors.states && touched.states ? (
																<div
																	className={`red mb-1 fs15`}
																	style={{ color: 'red' }}
																>
																	{errors.states}
																</div>
															) : null}
														</InputGroup>
													</Col>
													<Col sm={6}>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text className='fw-bold'>
																City <span style={{ color: 'red' }}>*</span>
															</InputGroup.Text>

															<Form.Control
																onChange={handleChange}
																value={values.city}
																maxlength='70'
																name='city'
																rows='1'
																className={`${
																	errors.city && touched.city ? 'error' : ''
																}`}
																placeholder='Enter city here'
															/>
															{/* <option value="" disabled selected>
                                  Select City
                                </option> */}
															{/* return(
                                {citiesData.map((item, i) => {
                                  return <option value={item.id}>{item.name}</option>;
                                })}
                                ) */}

															{errors.city && touched.city ? (
																<div
																	className={`red mb-1 fs15`}
																	style={{ color: 'red' }}
																>
																	{errors.city}
																</div>
															) : null}
														</InputGroup>
													</Col>
												</Row>
											</Col>
										</Row>
									</Form>

									{/* Job Specifications */}

									<Form style={{ border: '1px solid', marginTop: '12px' }}>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Job Specifications
													</h4>
												</div>
											</Col>
										</Row>
										{/*  Years Experiance*/}
										<Row style={{ marginLeft: '4px' }}>
											<Col sm={6}>
												<InputGroup controlId='formBasicEmail' className='mb-4'>
													<InputGroup.Text className='fw-bold'>
														Years Experience:
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>

													<Form.Control
														as='select'
														custom
														name='year_experience'
														onChange={handleChange}
														required
													>
														<option disabled selected>
															Select Year Experience
														</option>
														<option value='1-3'>1-3</option>
														<option value='4-6'>4-6</option>
														<option value='7-10'>7-10</option>
														<option value='10+'>10+</option>
														{errors.year_experience &&
														touched.year_experience ? (
															<div
																className={`red mb-1 fs15`}
																style={{ fontWeight: '400', color: 'red' }}
															>
																{errors.year_experience}
															</div>
														) : null}
													</Form.Control>
												</InputGroup>
											</Col>
											<Col sm={6}></Col>
										</Row>
										{/* Pay Rate Range */}
										<Row style={{ marginLeft: '4px' }}>
											<Col sm={6}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														Overtime Pay 
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>
													<InputGroup.Text className='fw-bold'>
														Low End
													</InputGroup.Text>

													{/* <Form.Control
                            onChange={handleChange}
                            name="start_pay_range"
                            type="number"
                            min="0"
                            oninput="this.value = Math.abs(this.value)"
                            inputMode="numeric" 
                            className={`${errors.start_pay_range && touched.start_pay_range
                                ? "error"
                                : ""
                              }`}
                            placeholder={"From"}
                          /> */}

													<Form.Control
														onChange={handleChange}
														name='start_pay_range'
														type='text'
														min='0'
														onInput={e => {
															e.target.value = e.target.value.replace(
																/[^0-9\.]/g,
																''
															);
														}}
														inputMode='numeric'
														className={`${
															errors.start_pay_range && touched.start_pay_range
																? 'error'
																: ''
														}`}
														placeholder={'From'}
													/>

													{errors.start_pay_range && touched.start_pay_range ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.start_pay_range}
														</div>
													) : null}
												</InputGroup>
											</Col>
											<Col sm={1}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														To
													</InputGroup.Text>
												</InputGroup>
											</Col>
											<Col sm={5}>
												<InputGroup
													controlId='formBasicEmail'
													style={{ width: '96%' }}
												>
													<InputGroup.Text className='fw-bold'>
														High End
													</InputGroup.Text>

													{/* <Form.Control
                            min={values.start_pay_range}
                            onChange={handleChange}
                            name="end_pay_range"
                            type="number"
                            oninput="this.value = Math.abs(this.value)"
                            className={`${errors.end_pay_range && touched.end_pay_range
                                ? "error"
                                : ""
                              }`}
                            placeholder={"To"}
                          /> */}
													<Form.Control
														// min={values.start_pay_range}
														onChange={handleChange}
														name='end_pay_range'
														type='text'
														onInput={e => {
															e.target.value = e.target.value.replace(
																/[^0-9\.]/g,
																''
															);
														}}
														className={`${
															errors.end_pay_range && touched.end_pay_range
																? 'error'
																: ''
														}`}
														placeholder={'To'}
													/>
													{errors.end_pay_range && touched.end_pay_range ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.end_pay_range}
														</div>
													) : null}
													{feeError ? (
														<p style={{ color: 'red' }}>
															initial value is smaller than final Value
														</p>
													) : (
														''
													)}
												</InputGroup>
											</Col>

											<Col
												className='fw-bold p-1 mt-3 rounded'
												style={{ marginLeft: '12px' }}
											>
												{' '}
												<InputGroup
													controlId='formBasicEmail'
													style={{ width: '98%' }}
												>
													<InputGroup.Text className='fw-bold'>
														Overtime Hourly Pay
														<Form.Check
															size='lg'
															custom
															inline
															name='overtime'
															onChange={overtimeTravel}
															type='switch'
															id='custom-switch1'
															label=''
															className='ms-2'
														/>
													</InputGroup.Text>
												</InputGroup>
												{overtime ? (
													<Form.Group
														controlId='newJobDestination'
														className='mt-3'
													>
														<Row>
															<Col sm={6}>
																<InputGroup controlId='formBasicEmail'>
																	<InputGroup.Text className='fw-bold'>
																		Overtime Pay 
																		{/* <span style={{ color: "red" }}>*</span> */}
																	</InputGroup.Text>
																	<InputGroup.Text className='fw-bold'>
																		Low End
																	</InputGroup.Text>
																	{/* <Form.Control
                                        onChange={handleChange}
                                        name="start_pay_range"
                                        type="number"
                                        min="0"
                                        oninput="this.value = Math.abs(this.value)"
                                        inputMode="numeric" 
                                        className={`${errors.start_pay_range && touched.start_pay_range
                                            ? "error"
                                            : ""
                                          }`}
                                        placeholder={"From"}
                                      /> */}

																	<Form.Control
																		onChange={handleChange}
																		name='start_pay_range1'
																		type='text'
																		min='0'
																		onInput={e => {
																			e.target.value = e.target.value.replace(
																				/[^0-9\.]/g,
																				''
																			);
																		}}
																		inputMode='numeric'
																		className={`${
																			errors.start_pay_range1 &&
																			touched.start_pay_range1
																				? 'error'
																				: ''
																		}`}
																		placeholder={'From'}
																	/>

																	{/* {errors.start_pay_range && touched.start_pay_range ? (
                                    <div className={`red mb-1 fs15`}>
                                      {errors.start_pay_range}
                                    </div>
                                  ) : null} */}
																</InputGroup>
															</Col>
															<Col sm={1}>
																<InputGroup controlId='formBasicEmail'>
																	<InputGroup.Text className='fw-bold'>
																		To
																	</InputGroup.Text>
																</InputGroup>
															</Col>
															<Col sm={5}>
																<InputGroup
																	controlId='formBasicEmail'
																	style={{ width: '93%' }}
																>
																	<InputGroup.Text className='fw-bold'>
																		High End
																	</InputGroup.Text>

																	{/* <Form.Control
                                      min={values.start_pay_range}
                                      onChange={handleChange}
                                      name="end_pay_range"
                                      type="number"
                                      oninput="this.value = Math.abs(this.value)"
                                      className={`${errors.end_pay_range && touched.end_pay_range
                                          ? "error"
                                          : ""
                                        }`}
                                      placeholder={"To"}
                                    /> */}
																	<Form.Control
																		min={values.start_pay_range1}
																		onChange={handleChange}
																		name='end_pay_range1'
																		type='text'
																		onInput={e => {
																			e.target.value = e.target.value.replace(
																				/[^0-9\.]/g,
																				''
																			);
																		}}
																		className={`${
																			errors.end_pay_range1 &&
																			touched.end_pay_range1
																				? 'error'
																				: ''
																		}`}
																		placeholder={'To'}
																	/>
																	{/* {errors.end_pay_range && touched.end_pay_range ? (
                                    <div className={`red mb-1 fs15`}>
                                      {errors.end_pay_range}
                                    </div>
                                  ) : null} */}
																	{feeError ? (
																		<p style={{ color: 'red' }}>
																			initial value is smaller than final Value
																		</p>
																	) : (
																		''
																	)}
																</InputGroup>
															</Col>
														</Row>
													</Form.Group>
												) : (
													''
												)}
											</Col>
										</Row>
										{/* Job Description  */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Job Description <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mt-4 mb-4'>
												<Form.Control
													as='textarea'
													onChange={handleChange}
													value={values.description}
													rows='3'
													name='description'
													className={`${
														errors.description && touched.description
															? 'error'
															: ''
													}`}
													placeholder='Enter Job description here'
												/>
												{errors.description && touched.description ? (
													<div
														className={`red mb-1 fs15`}
														style={{ color: 'red' }}
													>
														{errors.description}
													</div>
												) : null}
											</Col>
										</Row>

										{/* Select General & Specific Expertise */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Select General & Specific Expertise{' '}
												<span style={{ color: 'red' }}>*</span>{' '}
												<span
													style={{ fontWeight: 'bold', marginLeft: '150px' ,fontSize:'12px'}}
												>
													Note:
												</span>
												<span style={{ fontWeight: '600', marginLeft: '6px' ,fontSize:'12px'}}>
												Please select at least one Primary General and one Specific Field{' '}
												</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											{/*  */}
											<Row
												style={{
													marginTop: '15px',
													marginBottom: '15px',
												}}
											>
												<Col md={4}>
													<InputGroup
														controlId='formBasicEmail'
														style={{ marginLeft: '12px' }}
													>
														<InputGroup.Text
															className='fw-bold'
															style={{ width: '94px' }}
														>
															Primary <br /> General
														</InputGroup.Text>

														{/*  Parent  */}
														<ParentTagsScreen
															selectedParent={selectedParent}
															// header="Select Parent Tag"
															hideParentTag={hideParentTag}
															returnedTags={returnedTags}
															selectParentTag={selectParentTag}
															checked={checked1}
														/>
													</InputGroup>
												</Col>
												{/* 1st child */}

												<Col md={4} style={{ marginLeft: '34px' }}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Specific <br /> Field 1
														</InputGroup.Text>

														{/* /// showChildren */}
														<NewChildTag
															// header="Select Child Tag"
															hideChildrenTag={hideChildrenTag}
															parent={parent}
															activeList={activeList}
															childTags={childTags}
															childSelection={childSelection}
															selectedChild={selectedChild}
															showParent={showParent}
															childChecked={childChecked}
														/>
													</InputGroup>
												</Col>
												{/* 2nd child */}
												<Col md={3}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Specific <br /> Field 2
														</InputGroup.Text>

														{selectedChild.length >= 1 && (
															<NewChildTag
																// header="Select Child Tag"
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags2nd}
																childSelection={childSelection2nd}
																selectedChild={selectedChild2nd}
																// showParent={showParent}
																childChecked={childChecked2nd}
															/>
														)}
													</InputGroup>
												</Col>
											</Row>
											{/* {selectedChild.length >= 1 && ( */}
											<Row
												style={{
													marginTop: '15px',
													marginBottom: '15px',
												}}
											>
												<Col md={4}>
													<InputGroup
														controlId='formBasicEmail'
														style={{ marginLeft: '10px' }}
													>
														<InputGroup.Text
															className='fw-bold'
															style={{ width: '96px' }}
														>
															Secondary <br /> General
														</InputGroup.Text>

														{/*  Parent  */}
														<ParentTagsScreen
															selectedParent={selectedParent2}
															// header="Select Parent Tag"
															hideParentTag={hideParentTag}
															returnedTags={returnedTags}
															selectParentTag={selectParentTag2}
															checked={checked2}
														/>
													</InputGroup>
												</Col>
												{/* 3rd child */}
												<Col md={4} style={{ marginLeft: '32px' }}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Specific <br /> Field 1
														</InputGroup.Text>

														{/* /// showChildren */}
														<NewChildTag
															// header="Select Child Tag"
															hideChildrenTag={hideChildrenTag}
															parent={parent}
															activeList={activeList}
															childTags={childTags2}
															childSelection={childSelection2}
															showParent={showParent}
															selectedChild={selectedChild2}
															childChecked={childChecked2}
														/>
													</InputGroup>
												</Col>
												{/* 4th child */}
												<Col md={3}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Specific <br /> Field 2
														</InputGroup.Text>

														{selectedChild2.length >= 1 && (
															<NewChildTag
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags3}
																childSelection={childSelection3}
																// showParent={showParent}
																selectedChild={selectedChild3}
																childChecked={childChecked3}
															/>
														)}
													</InputGroup>
												</Col>
											</Row>

											{/* )} */}
										</Row>
										{/* Required Skills */}

										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Required Skills <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mt-2'>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{expertise?.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			
																			onChange={e =>
																				handleInputChangeExpertise(e, i)
																			}
																			as='textarea'
																			rows='1'
																			placeholder='Add Skills'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<div className='btn-box'>
																		{/* <Button variant="outline-success">Success</Button> */}
																		{expertise.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() => handleRemoveExpertise(i)}
																			>
																				Remove this Required Skills
																			</Button>
																		)}
																		{expertise.length - 1 === i &&
																			expertise.length < 10 && (
																				<Button
																					className='mt-3'
																					variant='outline-success'
																					onClick={() => handleAddExpertise()}
																				>
																					Add Skills
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
										{/* Recommended Skills */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Recommended Skills
												{/* <span style={{ color: "red" }}>*</span> */}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mt-2'>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{otherRequirements.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			name='requirement'
																			onChange={e =>
																				handleInputChangeOtherRequirement(e, i)
																			}
																			as='textarea'
																			rows='1'
																			placeholder='Add skills'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<div className='btn-box'>
																		{/* <Button variant="outline-success">Success</Button> */}
																		{otherRequirements?.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() =>
																					handleRemoveOtherRequirement(i)
																				}
																			>
																				Remove this Recommended Skills
																			</Button>
																		)}
																		{otherRequirements.length - 1 === i &&
																			otherRequirements.length < 10 && (
																				<Button
																					className='mt-3'
																					variant='outline-success'
																					onClick={() =>
																						handleAddOtherRequirements()
																					}
																				>
																					Add Skills
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
										{/* Tool Required/Recommended */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Tool Required/Recommended
												<span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '15px',
											}}
										>
											<Col sm={12} className='mt-2'>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{tools?.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			name='tools'
																			onChange={e =>
																				handleInputChangeTools(e, i)
																			}
																			as='textarea'
																			rows='1'
																			placeholder='Add Tool'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<Row>
																		<Col sm={6}>
																			<InputGroup
																				controlId='formBasicEmail'
																				className='mb-4 mt-3'
																			>
																				<InputGroup.Text className='fw-bold'>
																					Must Own Tools:
																				</InputGroup.Text>

																				<Form.Control
																					as='select'
																					onChange={event =>
																						handleChangeMustOwnTools(
																							event.target.value
																						)
																					}
																					name='must_own_tools'
																				>
																					<option value='' disabled selected>
																						Select Options
																					</option>
																					<option value='yes'>Yes</option>
																					<option value='no'>No</option>
																				</Form.Control>
																			</InputGroup>
																		</Col>
																		<Col sm={6}>
																			<InputGroup
																				controlId='formBasicEmail'
																				className='mb-2 mt-3'
																			>
																				<InputGroup.Text className='fw-bold'>
																					Client Provides Tool:
																				</InputGroup.Text>

																				<Form.Control
																					as='select'
																					// onChange={handleChange}
																					onChange={event =>
																						handleChangeClientProvidesTools(
																							event.target.value
																						)
																					}
																					name='client_provides_tools'
																				>
																					<option value='' disabled selected>
																						Select Options
																					</option>
																					<option value='yes'>Yes</option>
																					<option value='no'>No</option>
																					<option value='may-be'>May be</option>
																				</Form.Control>
																			</InputGroup>
																		</Col>
																	</Row>
																	<div className='btn-box'>
																		{/* <Button variant="outline-success">Success</Button> */}
																		{tools?.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() => handleRemoveTools(i)}
																			>
																				Remove this Tool
																			</Button>
																		)}
																		{tools.length - 1 === i &&
																			tools.length < 10 && (
																				<Button
																					variant='outline-success'
																					onClick={() => handleAddTools()}
																				>
																					Add Tools
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
									</Form>

									{/* Location/Meeting/Travel */}
									<Form style={{ border: '1px solid', marginTop: '12px' }}>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Location/Meeting/Travel
													</h4>
												</div>
											</Col>
										</Row>

										{/* Location  */}
										<Row
											className='bg-label'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Location <span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mt-3 ms-5  '>
												<div
													style={{ marginBottom: '15px' }}
													key={`custom-inline-checkbox`}
												>
													<Form.Check
														custom
														inline
														label='On-Site'
														value='onsite'
														name='job_location'
														onChange={handleChange}
														type={`radio`}
														id={`custom-inline-checkbox-1`}
														style={{ marginRight: '5rem' }}
													/>
													<Form.Check
														custom
														inline
														label='Remote'
														value='remote'
														name='job_location'
														onChange={handleChange}
														type={`radio`}
														id={`custom-inline-checkbox-2`}
														style={{ marginRight: '5rem' }}
													/>
													<Form.Check
														custom
														inline
														label='Both'
														value='both'
														name='job_location'
														onChange={handleChange}
														type={`radio`}
														id={`custom-inline-checkbox-3`}
													/>
													{errors.job_location && touched.job_location ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.job_location}
														</div>
													) : null}
												</div>
											</Col>
										</Row>
										{/* On-Site Meetings Required */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												On-Site Meetings Required{' '}
												<span style={{ color: 'red' }}>*</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col sm={12} className='mt-3 ms-5 '>
												<div
													style={{ marginBottom: '15px' }}
													key={`custom-inline-checkbox`}
												>
													<Form.Check
														custom
														inline
														label='Yes'
														name='onsite_meetings'
														onChange={handleChange}
														value='yes'
														type={`radio`}
														id={`on-site-meeting-yes`}
														style={{ marginRight: '5rem' }}
													/>
													<Form.Check
														custom
														inline
														label='No'
														name='onsite_meetings'
														onChange={handleChange}
														value='no'
														type={`radio`}
														id={`on-site-meeting-no`}
														style={{ marginRight: '5rem' }}
													/>
													{errors.onsite_meetings && touched.onsite_meetings ? (
														<div
															className={`red mb-1 fs15`}
															style={{ color: 'red' }}
														>
															{errors.onsite_meetings}
														</div>
													) : null}
												</div>
											</Col>
										</Row>
										{/* Requires Travel */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.7%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Requires Travel
												{/* <span style={{ color: "red" }}>*</span> */}
												<Form.Check
													size='lg'
													custom
													inline
													name='requires_travel'
													onChange={checkTravel}
													type='switch'
													id='custom-switch'
													label=''
													className='ms-2'
												/>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '18px',
											}}
										>
											<Col sm={12} className='mt-3 ms-1 '>
												{travel ? (
													<Form.Group
														controlId='newJobDestination'
														className='ms-5'
													>
														<div key={`custom-inline-checkbox`}>
															<Form.Check
																custom
																inline
																label='In State'
																value='InState'
																onChange={handleChange}
																name='travel_type'
																type={`radio`}
																id={`destination-in-state`}
															/>
															<Form.Check
																custom
																inline
																label='Domestic (US Only)'
																value='Domestic'
																onChange={handleChange}
																name='travel_type'
																type={`radio`}
																id={`destination-domestic`}
															/>
															<Form.Check
																custom
																inline
																label='International'
																value='International'
																onChange={handleChange}
																name='travel_type'
																type={`radio`}
																id={`destination-international`}
															/>
														</div>
														<Row>
															<Col>
																<Form.Control
																	name='destination'
																	onChange={handleChange}
																	rows='1'
																	as='textarea'
																	maxlength='70'
																	placeholder='Enter destination here'
																/>

																<span
																	style={{
																		fontSize: '12px',
																		color: '#007bff',
																		fontWeight: 700,
																		width: '60px',
																	}}
																>
																	<b>
																		<u>Info:</u>
																	</b>
																	<br />
																	Please add City, State and/or Country” “If
																	adding multiple locations place a semicolon
																	‘;’ between locations.
																</span>
															</Col>
															<Col md='auto'>
																<Form.Label className='mt-2 text-orange'>
																	Duration of Travel
																</Form.Label>
															</Col>
															<Col xs lg='2'>
																<Form.Control
																	onChange={handleChange}
																	name='travel_duration'
																	type='number'
																	min='0'
																	oninput='this.value = Math.abs(this.value)'
																	placeholder={'0'}
																/>
															</Col>
														</Row>

														<Row className='mb-3'>
															<Col>
																<Form.Control
																	// name="abc"
																	style={{ display: 'none' }}
																/>
															</Col>
															<Col md='auto'>
																<Form.Label className='mt-2 text-orange'>
																	Approx. Duration of Travel (%)
																</Form.Label>
															</Col>
															<Col xs lg='2'>
																<Form.Group controlId='newJobPrioLevel'>
																	<Form.Control
																		as='select'
																		custom
																		name='approx_duration'
																		onChange={handleChange}
																		placeholder='Select approx. duration of travel'
																		required
																	>
																		<option value='10'>10</option>
																		<option value='20'>20</option>
																		<option value='30'>30</option>
																		<option value='40'>40</option>
																		<option value='50'>50</option>
																		<option value='60'>60</option>
																		<option value='70'>70</option>
																		<option value='80'>80</option>
																		<option value='90'>90</option>
																		<option value='100'>100</option>
																	</Form.Control>
																</Form.Group>
															</Col>
														</Row>
													</Form.Group>
												) : (
													''
												)}
											</Col>
										</Row>
									</Form>

									{/* <Form.Group controlId="newJobSq">
                    <Form.Label className="text-primary">
                      Specific qualifications{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      onChange={handleChange}
                      value={values.specific_qualification}
                      maxlength="70"
                      rows="1"
                      name="specific_qualification"
                      className={`${
                        errors.specific_qualification &&
                        touched.specific_qualification
                          ? "error"
                          : ""
                      }`}
                      placeholder="Enter specific qualification here"
                    />
                    {errors.specific_qualification &&
                    touched.specific_qualification ? (
                      <div className={`red mb-1 fs15`}>
                        {errors.specific_qualification}
                      </div>
                    ) : null}
                  </Form.Group> */}

									{/* <Form.Group controlId="Tags">
                    <Form.Label className="text-primary">Tags</Form.Label>
                    <Multiselect
                      displayValue='label'
                      selectedValues={selectedTags}
                      groupBy="parent"
                      onRemove={selectTags}
                      onSelect={selectTags}
                      options={returnedTags}

                    />
                  </Form.Group> */}

									{/*  */}
									{/* <Form.Group controlId="Tags">
                    <Form.Label className="text-primary">Tags</Form.Label>
                    <Multiselect
                      displayValue='label'
                      selectedValues={selectedTags}
                      groupBy="parent"
                      onRemove={selectTags}
                      onSelect={selectTags}
                      options={returnedTags}

                    />
                  </Form.Group> */}

									{/*<hr></hr>

                      <Form.Group controlId="newJobLocation">
                        <Form.Label className="text-primary">Location</Form.Label>
                        <AsyncTypeahead
                          isLoading={isLoading}
                          id="address_typehead"
                          name="address"
                          labelKey="description"
                          placeholder="Search for a Location"
                          minLength={3}
                          onSearch={(key) => handleLocationSearch(key, setLocations)}
                          onChange={(obj) => handleLocationChange(obj, setFieldValue)}
                          options={locations}
                          className={`${errors.address && touched.address ? 'error' : ''}`}
                        />
                      </Form.Group> */}

									<div className={'text-center mt-4'}>
										{profile?.user?.is_subscribed === 1 ? (
											<Button
												onClick={() =>
													handleButtonClick(
														1,
														setFieldValue,
														submitForm,
														errors
													)
												}
												className='btn-new-client w-auto'
												style={{
													backgroundColor: '#e17739',
													borderColor: '#e17739',
												}}
											>
												<PlusCircleIcon size={16} />{' '}
												<span style={{ fontWeight: '500' }}>
													Publish Job Opportunity
												</span>
											</Button>
										) : null}
										<Button
											onClick={() =>
												handleButtonClick(0, setFieldValue, submitForm, errors)
											}
											className='btn-new-client btn-orange'
										>
											<PlusCircleIcon size={16} />{' '}
											<span style={{ fontWeight: '500' }}>Draft Job</span>
										</Button>
									</div>
								</Form>
							)}
						</Formik>
					</Col>
				</Row>
				<div style={{ height: '142px' }} />
			</Container>

			<Footer />
		</Container>
	);
}

export default AddNewJob;
